// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from "./client"
import { client } from "./client.gen"
import type {
  AddAddress1Data,
  AddAddress1Errors,
  AddAddress1Responses,
  AddAddressData,
  AddAddressErrors,
  AddAddressResponses,
  AddItemToCartData,
  AddItemToCartErrors,
  AddItemToCartResponses,
  AllCategoriesData,
  AllCategoriesErrors,
  AllCategoriesResponses,
  ApplyCredit1Data,
  ApplyCredit1Errors,
  ApplyCredit1Responses,
  ApplyDiscountData,
  ApplyDiscountErrors,
  ApplyDiscountResponses,
  AutocompleteAddressData,
  AutocompleteAddressErrors,
  AutocompleteAddressResponses,
  BootstrapV2Data,
  BootstrapV2Errors,
  BootstrapV2Responses,
  CapabilitiesData,
  CapabilitiesErrors,
  CapabilitiesResponses,
  CheckSignupEmailData,
  CheckSignupEmailErrors,
  CheckSignupEmailResponses,
  CompleteCheckoutData,
  CompleteCheckoutErrors,
  CompleteCheckoutResponses,
  ConfirmBillPayLoanData,
  ConfirmBillPayLoanErrors,
  ConfirmBillPayLoanResponses,
  ConfirmBnplOrderLoanData,
  ConfirmBnplOrderLoanErrors,
  ConfirmBnplOrderLoanResponses,
  ConfirmDirectLoanData,
  ConfirmDirectLoanErrors,
  ConfirmDirectLoanResponses,
  ConfirmVerificationCodeData,
  ConfirmVerificationCodeErrors,
  ConfirmVerificationCodeForUserData,
  ConfirmVerificationCodeForUserErrors,
  ConfirmVerificationCodeForUserResponses,
  ConfirmVerificationCodeResponses,
  ConvertLegacyDraftData,
  ConvertLegacyDraftErrors,
  ConvertLegacyDraftResponses,
  CreateApplicantData,
  CreateApplicantErrors,
  CreateApplicantResponses,
  CreateBillData,
  CreateBillErrors,
  CreateBillPayLoanData,
  CreateBillPayLoanErrors,
  CreateBillPayLoanResponses,
  CreateBillResponses,
  CreateBnplOrderLoanData,
  CreateBnplOrderLoanErrors,
  CreateBnplOrderLoanResponses,
  CreateCampaignDraftData,
  CreateCampaignDraftErrors,
  CreateCampaignDraftResponses,
  CreateCheckData,
  CreateCheckErrors,
  CreateCheckResponses,
  CreateCollectionData,
  CreateCollectionErrors,
  CreateCollectionResponses,
  CreateData,
  CreateDirectLoanData,
  CreateDirectLoanErrors,
  CreateDirectLoanResponses,
  CreateDocumentCheckData,
  CreateDocumentCheckErrors,
  CreateDocumentCheckResponses,
  CreateErrors,
  CreateFeedCampaignData,
  CreateFeedCampaignErrors,
  CreateFeedCampaignResponses,
  CreateResponses,
  CreateVerificationApplicantData,
  CreateVerificationApplicantErrors,
  CreateVerificationApplicantResponses,
  CreateVerificationCode2Data,
  CreateVerificationCode2Errors,
  CreateVerificationCode2Responses,
  CreateWishlistData,
  CreateWishlistErrors,
  CreateWishlistResponses,
  DeleteAddressData,
  DeleteAddressErrors,
  DeleteAddressResponses,
  DeleteData,
  DeleteErrors,
  DeleteProfileData,
  DeleteProfileErrors,
  DeleteProfileResponses,
  DeleteResponses,
  DeleteUploadByBodyData,
  DeleteUploadByBodyErrors,
  DeleteUploadByBodyResponses,
  EditFromVersionData,
  EditFromVersionErrors,
  EditFromVersionResponses,
  GenerateCurpData,
  GenerateCurpErrors,
  GenerateCurpResponses,
  GetAddressData,
  GetAddressErrors,
  GetAddressResponses,
  GetBillPaymentOptionsData,
  GetBillPaymentOptionsErrors,
  GetBillPaymentOptionsResponses,
  GetCarouselsData,
  GetCarouselsErrors,
  GetCarouselsResponses,
  GetCart1Data,
  GetCart1Errors,
  GetCart1Responses,
  GetCartByIdData,
  GetCartByIdErrors,
  GetCartByIdResponses,
  GetCatalogCarouselsData,
  GetCatalogCarouselsErrors,
  GetCatalogCarouselsResponses,
  GetCategory1Data,
  GetCategory1Errors,
  GetCategory1Responses,
  GetCollection1Data,
  GetCollection1Errors,
  GetCollection1Responses,
  GetContractPreviewData,
  GetContractPreviewErrors,
  GetContractPreviewResponses,
  GetCustomerData,
  GetCustomerErrors,
  GetCustomerResponses,
  GetData,
  GetErrors,
  GetFeaturedCoreProductsData,
  GetFeaturedCoreProductsErrors,
  GetFeaturedCoreProductsResponses,
  GetFeedCampaignData,
  GetFeedCampaignErrors,
  GetFeedCampaignResponses,
  GetFeedData,
  GetFeedErrors,
  GetFeedResponses,
  GetIdsData,
  GetIdsErrors,
  GetIdsResponses,
  GetIdVerificationStatusData,
  GetIdVerificationStatusErrors,
  GetIdVerificationStatusResponses,
  GetLoanApplicationStateData,
  GetLoanApplicationStateErrors,
  GetLoanApplicationStateResponses,
  GetLoanOptionsData,
  GetLoanOptionsErrors,
  GetLoanOptionsResponses,
  GetMeData,
  GetMeErrors,
  GetMeResponses,
  GetMyWishlistData,
  GetMyWishlistErrors,
  GetMyWishlistResponses,
  GetOrCreateCodeData,
  GetOrCreateCodeErrors,
  GetOrCreateCodeResponses,
  GetOrder2Data,
  GetOrder2Errors,
  GetOrder2Responses,
  GetOrderByCartId1Data,
  GetOrderByCartId1Errors,
  GetOrderByCartId1Responses,
  GetOrderCustomerData,
  GetOrderCustomerErrors,
  GetOrderCustomerResponses,
  GetOrderPaymentOptionsData,
  GetOrderPaymentOptionsErrors,
  GetOrderPaymentOptionsResponses,
  GetOrderWithFulfillmentsData,
  GetOrderWithFulfillmentsErrors,
  GetOrderWithFulfillmentsResponses,
  GetPaymentOptions1Data,
  GetPaymentOptions1Errors,
  GetPaymentOptions1Responses,
  GetPostalCodeDetailsData,
  GetPostalCodeDetailsErrors,
  GetPostalCodeDetailsResponses,
  GetPostCheckoutPathData,
  GetPostCheckoutPathErrors,
  GetPostCheckoutPathResponses,
  GetPotentialPhysicalCardCardholderNamesData,
  GetPotentialPhysicalCardCardholderNamesErrors,
  GetPotentialPhysicalCardCardholderNamesResponses,
  GetProduct1Data,
  GetProduct1Errors,
  GetProduct1Responses,
  GetProductByHandleData,
  GetProductByHandleErrors,
  GetProductByHandleResponses,
  GetProductDiscountsData,
  GetProductDiscountsErrors,
  GetProductDiscountsResponses,
  GetProfileData,
  GetProfileErrors,
  GetProfileResponses,
  GetPublicRetailDisplayPaymentOptionsData,
  GetPublicRetailDisplayPaymentOptionsErrors,
  GetPublicRetailDisplayPaymentOptionsResponses,
  GetResponses,
  GetTreatmentData,
  GetTreatmentErrors,
  GetTreatmentResponses,
  GetUnsignedLoanContract1Data,
  GetUnsignedLoanContract1Errors,
  GetUnsignedLoanContract1Responses,
  GetUserAddresses2Data,
  GetUserAddresses2Errors,
  GetUserAddresses2Responses,
  GetVersionData,
  GetVersionErrors,
  GetVersionResponses,
  GetWishlistData,
  GetWishlistErrors,
  GetWishlistResponses,
  HandoffData,
  HandoffErrors,
  HandoffResponses,
  Link1Data,
  Link1Errors,
  Link1Responses,
  ListCampaignDraftsData,
  ListCampaignDraftsErrors,
  ListCampaignDraftsResponses,
  ListCategories1Data,
  ListCategories1Errors,
  ListCategories1Responses,
  ListCollections1Data,
  ListCollections1Errors,
  ListCollections1Responses,
  ListCollectionsData,
  ListCollectionsErrors,
  ListCollectionsResponses,
  ListData,
  ListErrors,
  ListFeedCampaignsData,
  ListFeedCampaignsErrors,
  ListFeedCampaignsResponses,
  ListOrdersData,
  ListOrdersErrors,
  ListOrdersResponses,
  ListRegions1Data,
  ListRegions1Errors,
  ListRegions1Responses,
  ListResponses,
  ListReviewsData,
  ListReviewsErrors,
  ListReviewsResponses,
  ListSitemapProductsData,
  ListSitemapProductsErrors,
  ListSitemapProductsResponses,
  ListVersionsData,
  ListVersionsErrors,
  ListVersionsResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LogoutData,
  LogoutErrors,
  LogoutResponses,
  NotifyOrderVoidData,
  NotifyOrderVoidErrors,
  NotifyOrderVoidResponses,
  Oauth2RevokeData,
  Oauth2RevokeErrors,
  Oauth2RevokeResponses,
  Oauth2TokenData,
  Oauth2TokenErrors,
  Oauth2TokenResponses,
  OrderPhysicalCardData,
  OrderPhysicalCardErrors,
  OrderPhysicalCardResponses,
  PatchFeedCampaignData,
  PatchFeedCampaignErrors,
  PatchFeedCampaignResponses,
  PinData,
  PinErrors,
  PinResponses,
  PrepareBnplPaymentIntentData,
  PrepareBnplPaymentIntentErrors,
  PrepareBnplPaymentIntentResponses,
  PreviewCodeData,
  PreviewCodeErrors,
  PreviewCodeResponses,
  PreviewData,
  PreviewErrors,
  PreviewResponses,
  PublishCampaignDraftData,
  PublishCampaignDraftErrors,
  PublishCampaignDraftResponses,
  PublishData,
  PublishErrors,
  PublishLiveData,
  PublishLiveErrors,
  PublishLiveResponses,
  PublishResponses,
  PutProfileData,
  PutProfileErrors,
  PutProfileResponses,
  RemoveAddressData,
  RemoveAddressErrors,
  RemoveAddressResponses,
  RemoveCredit1Data,
  RemoveCredit1Errors,
  RemoveCredit1Responses,
  RemoveDiscountData,
  RemoveDiscountErrors,
  RemoveDiscountResponses,
  RemoveItemData,
  RemoveItemErrors,
  RemoveItemResponses,
  RemoveLineItemData,
  RemoveLineItemErrors,
  RemoveLineItemResponses,
  ResetPin1Data,
  ResetPin1Errors,
  ResetPin1Responses,
  ResolveData,
  ResolveErrors,
  ResolveResponses,
  Restore1Data,
  Restore1Errors,
  Restore1Responses,
  SaveCampaignDraftData,
  SaveCampaignDraftErrors,
  SaveCampaignDraftResponses,
  SaveExperimentVersionData,
  SaveExperimentVersionErrors,
  SaveExperimentVersionResponses,
  SaveItemData,
  SaveItemErrors,
  SaveItemResponses,
  SessionData,
  SessionErrors,
  SessionResponses,
  SetDefaultVersionData,
  SetDefaultVersionErrors,
  SetDefaultVersionResponses,
  SetImage1Data,
  SetImage1Errors,
  SetImage1Responses,
  SetImageData,
  SetImageErrors,
  SetImageResponses,
  SetPinData,
  SetPinErrors,
  SetPinResponses,
  SetUserPinData,
  SetUserPinErrors,
  SetUserPinResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  SignupV4Data,
  SignupV4Errors,
  SignupV4Responses,
  TransferWishlistToCustomerData,
  TransferWishlistToCustomerErrors,
  TransferWishlistToCustomerResponses,
  UnauthenticatedSearchData,
  UnauthenticatedSearchErrors,
  UnauthenticatedSearchResponses,
  Update1Data,
  Update1Errors,
  Update1Responses,
  UpdateAddress1Data,
  UpdateAddress1Errors,
  UpdateAddress1Responses,
  UpdateAddress3Data,
  UpdateAddress3Errors,
  UpdateAddress3Responses,
  UpdateCustomerData,
  UpdateCustomerErrors,
  UpdateCustomerResponses,
  UpdateDeliveryDetailsData,
  UpdateDeliveryDetailsErrors,
  UpdateDeliveryDetailsResponses,
  UpdateShippingAddressData,
  UpdateShippingAddressErrors,
  UpdateShippingAddressResponses,
  Upload1Data,
  Upload1Errors,
  Upload1Responses,
  UploadDocumentData,
  UploadDocumentErrors,
  UploadDocumentResponses,
  ValidateAddressData,
  ValidateAddressErrors,
  ValidateAddressResponses,
  ValidateCurpV3Data,
  ValidateCurpV3Errors,
  ValidateCurpV3Responses,
} from "./types.gen"

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

export const getAddress = <ThrowOnError extends boolean = false>(
  options: Options<GetAddressData, ThrowOnError>
): RequestResult<GetAddressResponses, GetAddressErrors, ThrowOnError> =>
  (options.client ?? client).get<GetAddressResponses, GetAddressErrors, ThrowOnError>({ url: "/address", ...options })

export const addAddress1 = <ThrowOnError extends boolean = false>(
  options: Options<AddAddress1Data, ThrowOnError>
): RequestResult<AddAddress1Responses, AddAddress1Errors, ThrowOnError> =>
  (options.client ?? client).post<AddAddress1Responses, AddAddress1Errors, ThrowOnError>({
    url: "/address",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const autocompleteAddress = <ThrowOnError extends boolean = false>(
  options: Options<AutocompleteAddressData, ThrowOnError>
): RequestResult<AutocompleteAddressResponses, AutocompleteAddressErrors, ThrowOnError> =>
  (options.client ?? client).get<AutocompleteAddressResponses, AutocompleteAddressErrors, ThrowOnError>({ url: "/address/autocomplete", ...options })

export const removeAddress = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAddressData, ThrowOnError>
): RequestResult<RemoveAddressResponses, RemoveAddressErrors, ThrowOnError> =>
  (options.client ?? client).delete<RemoveAddressResponses, RemoveAddressErrors, ThrowOnError>({ url: "/address/{uuid}", ...options })

export const updateAddress1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAddress1Data, ThrowOnError>
): RequestResult<UpdateAddress1Responses, UpdateAddress1Errors, ThrowOnError> =>
  (options.client ?? client).put<UpdateAddress1Responses, UpdateAddress1Errors, ThrowOnError>({
    url: "/address/{uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getUserAddresses2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserAddresses2Data, ThrowOnError>
): RequestResult<GetUserAddresses2Responses, GetUserAddresses2Errors, ThrowOnError> =>
  (options?.client ?? client).get<GetUserAddresses2Responses, GetUserAddresses2Errors, ThrowOnError>({ url: "/addresses", ...options })

export const getCart1 = <ThrowOnError extends boolean = false>(options?: Options<GetCart1Data, ThrowOnError>): RequestResult<GetCart1Responses, GetCart1Errors, ThrowOnError> =>
  (options?.client ?? client).get<GetCart1Responses, GetCart1Errors, ThrowOnError>({ url: "/api/marketplace/cart", ...options })

export const completeCheckout = <ThrowOnError extends boolean = false>(
  options: Options<CompleteCheckoutData, ThrowOnError>
): RequestResult<CompleteCheckoutResponses, CompleteCheckoutErrors, ThrowOnError> =>
  (options.client ?? client).post<CompleteCheckoutResponses, CompleteCheckoutErrors, ThrowOnError>({
    url: "/api/marketplace/cart/checkout",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const removeCredit1 = <ThrowOnError extends boolean = false>(
  options?: Options<RemoveCredit1Data, ThrowOnError>
): RequestResult<RemoveCredit1Responses, RemoveCredit1Errors, ThrowOnError> =>
  (options?.client ?? client).delete<RemoveCredit1Responses, RemoveCredit1Errors, ThrowOnError>({ url: "/api/marketplace/cart/credit", ...options })

export const applyCredit1 = <ThrowOnError extends boolean = false>(
  options?: Options<ApplyCredit1Data, ThrowOnError>
): RequestResult<ApplyCredit1Responses, ApplyCredit1Errors, ThrowOnError> =>
  (options?.client ?? client).post<ApplyCredit1Responses, ApplyCredit1Errors, ThrowOnError>({ url: "/api/marketplace/cart/credit", ...options })

export const applyDiscount = <ThrowOnError extends boolean = false>(
  options: Options<ApplyDiscountData, ThrowOnError>
): RequestResult<ApplyDiscountResponses, ApplyDiscountErrors, ThrowOnError> =>
  (options.client ?? client).post<ApplyDiscountResponses, ApplyDiscountErrors, ThrowOnError>({
    url: "/api/marketplace/cart/discounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const removeDiscount = <ThrowOnError extends boolean = false>(
  options: Options<RemoveDiscountData, ThrowOnError>
): RequestResult<RemoveDiscountResponses, RemoveDiscountErrors, ThrowOnError> =>
  (options.client ?? client).delete<RemoveDiscountResponses, RemoveDiscountErrors, ThrowOnError>({ url: "/api/marketplace/cart/discounts/{code}", ...options })

export const addItemToCart = <ThrowOnError extends boolean = false>(
  options: Options<AddItemToCartData, ThrowOnError>
): RequestResult<AddItemToCartResponses, AddItemToCartErrors, ThrowOnError> =>
  (options.client ?? client).post<AddItemToCartResponses, AddItemToCartErrors, ThrowOnError>({
    url: "/api/marketplace/cart/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const removeLineItem = <ThrowOnError extends boolean = false>(
  options: Options<RemoveLineItemData, ThrowOnError>
): RequestResult<RemoveLineItemResponses, RemoveLineItemErrors, ThrowOnError> =>
  (options.client ?? client).delete<RemoveLineItemResponses, RemoveLineItemErrors, ThrowOnError>({ url: "/api/marketplace/cart/items/{lineItemId}", ...options })

export const updateShippingAddress = <ThrowOnError extends boolean = false>(
  options: Options<UpdateShippingAddressData, ThrowOnError>
): RequestResult<UpdateShippingAddressResponses, UpdateShippingAddressErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateShippingAddressResponses, UpdateShippingAddressErrors, ThrowOnError>({
    url: "/api/marketplace/cart/shipping-address",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const updateDeliveryDetails = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDeliveryDetailsData, ThrowOnError>
): RequestResult<UpdateDeliveryDetailsResponses, UpdateDeliveryDetailsErrors, ThrowOnError> =>
  (options.client ?? client).patch<UpdateDeliveryDetailsResponses, UpdateDeliveryDetailsErrors, ThrowOnError>({
    url: "/api/marketplace/cart/shipping-address/delivery-details",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getCartById = <ThrowOnError extends boolean = false>(
  options: Options<GetCartByIdData, ThrowOnError>
): RequestResult<GetCartByIdResponses, GetCartByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<GetCartByIdResponses, GetCartByIdErrors, ThrowOnError>({ url: "/api/marketplace/carts/{cartId}", ...options })

export const getPaymentOptions1 = <ThrowOnError extends boolean = false>(
  options: Options<GetPaymentOptions1Data, ThrowOnError>
): RequestResult<GetPaymentOptions1Responses, GetPaymentOptions1Errors, ThrowOnError> =>
  (options.client ?? client).get<GetPaymentOptions1Responses, GetPaymentOptions1Errors, ThrowOnError>({ url: "/api/marketplace/carts/{cartId}/payment-options", ...options })

export const createBillPayLoan = <ThrowOnError extends boolean = false>(
  options: Options<CreateBillPayLoanData, ThrowOnError>
): RequestResult<CreateBillPayLoanResponses, CreateBillPayLoanErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateBillPayLoanResponses, CreateBillPayLoanErrors, ThrowOnError>({
    url: "/billpay-loan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const confirmBillPayLoan = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmBillPayLoanData, ThrowOnError>
): RequestResult<ConfirmBillPayLoanResponses, ConfirmBillPayLoanErrors, ThrowOnError> =>
  (options.client ?? client).put<ConfirmBillPayLoanResponses, ConfirmBillPayLoanErrors, ThrowOnError>({
    url: "/billpay-loan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const createBill = <ThrowOnError extends boolean = false>(
  options: Options<CreateBillData, ThrowOnError>
): RequestResult<CreateBillResponses, CreateBillErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateBillResponses, CreateBillErrors, ThrowOnError>({
    url: "/bills",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getBillPaymentOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetBillPaymentOptionsData, ThrowOnError>
): RequestResult<GetBillPaymentOptionsResponses, GetBillPaymentOptionsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBillPaymentOptionsResponses, GetBillPaymentOptionsErrors, ThrowOnError>({ url: "/bills/payment-options/{uuid}", ...options })

export const createBnplOrderLoan = <ThrowOnError extends boolean = false>(
  options: Options<CreateBnplOrderLoanData, ThrowOnError>
): RequestResult<CreateBnplOrderLoanResponses, CreateBnplOrderLoanErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateBnplOrderLoanResponses, CreateBnplOrderLoanErrors, ThrowOnError>({
    url: "/bnpl-order-loan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const confirmBnplOrderLoan = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmBnplOrderLoanData, ThrowOnError>
): RequestResult<ConfirmBnplOrderLoanResponses, ConfirmBnplOrderLoanErrors, ThrowOnError> =>
  (options.client ?? client).put<ConfirmBnplOrderLoanResponses, ConfirmBnplOrderLoanErrors, ThrowOnError>({
    url: "/bnpl-order-loan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const prepareBnplPaymentIntent = <ThrowOnError extends boolean = false>(
  options: Options<PrepareBnplPaymentIntentData, ThrowOnError>
): RequestResult<PrepareBnplPaymentIntentResponses, PrepareBnplPaymentIntentErrors, ThrowOnError> =>
  (options.client ?? client).post<PrepareBnplPaymentIntentResponses, PrepareBnplPaymentIntentErrors, ThrowOnError>({
    url: "/bnpl-order-loan/payment-intent",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const confirmVerificationCode = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmVerificationCodeData, ThrowOnError>
): RequestResult<ConfirmVerificationCodeResponses, ConfirmVerificationCodeErrors, ThrowOnError> =>
  (options.client ?? client).put<ConfirmVerificationCodeResponses, ConfirmVerificationCodeErrors, ThrowOnError>({
    url: "/code/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const createVerificationCode2 = <ThrowOnError extends boolean = false>(
  options: Options<CreateVerificationCode2Data, ThrowOnError>
): RequestResult<CreateVerificationCode2Responses, CreateVerificationCode2Errors, ThrowOnError> =>
  (options.client ?? client).post<CreateVerificationCode2Responses, CreateVerificationCode2Errors, ThrowOnError>({
    url: "/code/send",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const confirmVerificationCodeForUser = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmVerificationCodeForUserData, ThrowOnError>
): RequestResult<ConfirmVerificationCodeForUserResponses, ConfirmVerificationCodeForUserErrors, ThrowOnError> =>
  (options.client ?? client).put<ConfirmVerificationCodeForUserResponses, ConfirmVerificationCodeForUserErrors, ThrowOnError>({
    url: "/code/user/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const generateCurp = <ThrowOnError extends boolean = false>(
  options: Options<GenerateCurpData, ThrowOnError>
): RequestResult<GenerateCurpResponses, GenerateCurpErrors, ThrowOnError> =>
  (options.client ?? client).post<GenerateCurpResponses, GenerateCurpErrors, ThrowOnError>({
    url: "/curp/generate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const createDirectLoan = <ThrowOnError extends boolean = false>(
  options: Options<CreateDirectLoanData, ThrowOnError>
): RequestResult<CreateDirectLoanResponses, CreateDirectLoanErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateDirectLoanResponses, CreateDirectLoanErrors, ThrowOnError>({
    url: "/direct-loan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const confirmDirectLoan = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmDirectLoanData, ThrowOnError>
): RequestResult<ConfirmDirectLoanResponses, ConfirmDirectLoanErrors, ThrowOnError> =>
  (options.client ?? client).put<ConfirmDirectLoanResponses, ConfirmDirectLoanErrors, ThrowOnError>({
    url: "/direct-loan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getTreatment = <ThrowOnError extends boolean = false>(
  options: Options<GetTreatmentData, ThrowOnError>
): RequestResult<GetTreatmentResponses, GetTreatmentErrors, ThrowOnError> =>
  (options.client ?? client).post<GetTreatmentResponses, GetTreatmentErrors, ThrowOnError>({
    url: "/experimentation/get-treatment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getLoanOptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetLoanOptionsData, ThrowOnError>
): RequestResult<GetLoanOptionsResponses, GetLoanOptionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetLoanOptionsResponses, GetLoanOptionsErrors, ThrowOnError>({ url: "/loan/options", ...options })

export const getUnsignedLoanContract1 = <ThrowOnError extends boolean = false>(
  options: Options<GetUnsignedLoanContract1Data, ThrowOnError>
): RequestResult<GetUnsignedLoanContract1Responses, GetUnsignedLoanContract1Errors, ThrowOnError> =>
  (options.client ?? client).get<GetUnsignedLoanContract1Responses, GetUnsignedLoanContract1Errors, ThrowOnError>({ url: "/loans/{loanUuid}/contract-preview", ...options })

export const listCollections = <ThrowOnError extends boolean = false>(
  options?: Options<ListCollectionsData, ThrowOnError>
): RequestResult<ListCollectionsResponses, ListCollectionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListCollectionsResponses, ListCollectionsErrors, ThrowOnError>({ url: "/marketplace/admin/collections", ...options })

export const createCollection = <ThrowOnError extends boolean = false>(
  options: Options<CreateCollectionData, ThrowOnError>
): RequestResult<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError>({
    url: "/marketplace/admin/collections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const setImage1 = <ThrowOnError extends boolean = false>(options: Options<SetImage1Data, ThrowOnError>): RequestResult<SetImage1Responses, SetImage1Errors, ThrowOnError> =>
  (options.client ?? client).put<SetImage1Responses, SetImage1Errors, ThrowOnError>({
    url: "/marketplace/admin/collections/{id}/images",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const listFeedCampaigns = <ThrowOnError extends boolean = false>(
  options?: Options<ListFeedCampaignsData, ThrowOnError>
): RequestResult<ListFeedCampaignsResponses, ListFeedCampaignsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListFeedCampaignsResponses, ListFeedCampaignsErrors, ThrowOnError>({ url: "/marketplace/admin/feed/campaigns", ...options })

export const createFeedCampaign = <ThrowOnError extends boolean = false>(
  options: Options<CreateFeedCampaignData, ThrowOnError>
): RequestResult<CreateFeedCampaignResponses, CreateFeedCampaignErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateFeedCampaignResponses, CreateFeedCampaignErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/campaigns",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const listCampaignDrafts = <ThrowOnError extends boolean = false>(
  options?: Options<ListCampaignDraftsData, ThrowOnError>
): RequestResult<ListCampaignDraftsResponses, ListCampaignDraftsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListCampaignDraftsResponses, ListCampaignDraftsErrors, ThrowOnError>({ url: "/marketplace/admin/feed/campaigns/drafts", ...options })

export const createCampaignDraft = <ThrowOnError extends boolean = false>(
  options: Options<CreateCampaignDraftData, ThrowOnError>
): RequestResult<CreateCampaignDraftResponses, CreateCampaignDraftErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateCampaignDraftResponses, CreateCampaignDraftErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/campaigns/drafts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getFeedCampaign = <ThrowOnError extends boolean = false>(
  options: Options<GetFeedCampaignData, ThrowOnError>
): RequestResult<GetFeedCampaignResponses, GetFeedCampaignErrors, ThrowOnError> =>
  (options.client ?? client).get<GetFeedCampaignResponses, GetFeedCampaignErrors, ThrowOnError>({ url: "/marketplace/admin/feed/campaigns/{uuid}", ...options })

export const patchFeedCampaign = <ThrowOnError extends boolean = false>(
  options: Options<PatchFeedCampaignData, ThrowOnError>
): RequestResult<PatchFeedCampaignResponses, PatchFeedCampaignErrors, ThrowOnError> =>
  (options.client ?? client).patch<PatchFeedCampaignResponses, PatchFeedCampaignErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/campaigns/{uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const saveCampaignDraft = <ThrowOnError extends boolean = false>(
  options: Options<SaveCampaignDraftData, ThrowOnError>
): RequestResult<SaveCampaignDraftResponses, SaveCampaignDraftErrors, ThrowOnError> =>
  (options.client ?? client).put<SaveCampaignDraftResponses, SaveCampaignDraftErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/campaigns/{uuid}/draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const publishCampaignDraft = <ThrowOnError extends boolean = false>(
  options: Options<PublishCampaignDraftData, ThrowOnError>
): RequestResult<PublishCampaignDraftResponses, PublishCampaignDraftErrors, ThrowOnError> =>
  (options.client ?? client).post<PublishCampaignDraftResponses, PublishCampaignDraftErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/campaigns/{uuid}/publish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const capabilities = <ThrowOnError extends boolean = false>(
  options?: Options<CapabilitiesData, ThrowOnError>
): RequestResult<CapabilitiesResponses, CapabilitiesErrors, ThrowOnError> =>
  (options?.client ?? client).get<CapabilitiesResponses, CapabilitiesErrors, ThrowOnError>({ url: "/marketplace/admin/feed/capabilities", ...options })

export const list = <ThrowOnError extends boolean = false>(options?: Options<ListData, ThrowOnError>): RequestResult<ListResponses, ListErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListResponses, ListErrors, ThrowOnError>({ url: "/marketplace/admin/feed/pages", ...options })

export const create = <ThrowOnError extends boolean = false>(options: Options<CreateData, ThrowOnError>): RequestResult<CreateResponses, CreateErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateResponses, CreateErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const convertLegacyDraft = <ThrowOnError extends boolean = false>(
  options: Options<ConvertLegacyDraftData, ThrowOnError>
): RequestResult<ConvertLegacyDraftResponses, ConvertLegacyDraftErrors, ThrowOnError> =>
  (options.client ?? client).post<ConvertLegacyDraftResponses, ConvertLegacyDraftErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages/convert",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const delete_ = <ThrowOnError extends boolean = false>(options: Options<DeleteData, ThrowOnError>): RequestResult<DeleteResponses, DeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteResponses, DeleteErrors, ThrowOnError>({ url: "/marketplace/admin/feed/pages/{uuid}", ...options })

export const get = <ThrowOnError extends boolean = false>(options: Options<GetData, ThrowOnError>): RequestResult<GetResponses, GetErrors, ThrowOnError> =>
  (options.client ?? client).get<GetResponses, GetErrors, ThrowOnError>({ url: "/marketplace/admin/feed/pages/{uuid}", ...options })

export const update1 = <ThrowOnError extends boolean = false>(options: Options<Update1Data, ThrowOnError>): RequestResult<Update1Responses, Update1Errors, ThrowOnError> =>
  (options.client ?? client).put<Update1Responses, Update1Errors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages/{uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const setDefaultVersion = <ThrowOnError extends boolean = false>(
  options: Options<SetDefaultVersionData, ThrowOnError>
): RequestResult<SetDefaultVersionResponses, SetDefaultVersionErrors, ThrowOnError> =>
  (options.client ?? client).post<SetDefaultVersionResponses, SetDefaultVersionErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages/{uuid}/default",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const publish = <ThrowOnError extends boolean = false>(options: Options<PublishData, ThrowOnError>): RequestResult<PublishResponses, PublishErrors, ThrowOnError> =>
  (options.client ?? client).post<PublishResponses, PublishErrors, ThrowOnError>({ url: "/marketplace/admin/feed/pages/{uuid}/publish", ...options })

export const publishLive = <ThrowOnError extends boolean = false>(
  options: Options<PublishLiveData, ThrowOnError>
): RequestResult<PublishLiveResponses, PublishLiveErrors, ThrowOnError> =>
  (options.client ?? client).post<PublishLiveResponses, PublishLiveErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages/{uuid}/publish-live",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const restore1 = <ThrowOnError extends boolean = false>(options: Options<Restore1Data, ThrowOnError>): RequestResult<Restore1Responses, Restore1Errors, ThrowOnError> =>
  (options.client ?? client).post<Restore1Responses, Restore1Errors, ThrowOnError>({ url: "/marketplace/admin/feed/pages/{uuid}/restore", ...options })

export const listVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListVersionsData, ThrowOnError>
): RequestResult<ListVersionsResponses, ListVersionsErrors, ThrowOnError> =>
  (options.client ?? client).get<ListVersionsResponses, ListVersionsErrors, ThrowOnError>({ url: "/marketplace/admin/feed/pages/{uuid}/versions", ...options })

export const saveExperimentVersion = <ThrowOnError extends boolean = false>(
  options: Options<SaveExperimentVersionData, ThrowOnError>
): RequestResult<SaveExperimentVersionResponses, SaveExperimentVersionErrors, ThrowOnError> =>
  (options.client ?? client).post<SaveExperimentVersionResponses, SaveExperimentVersionErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages/{uuid}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetVersionData, ThrowOnError>
): RequestResult<GetVersionResponses, GetVersionErrors, ThrowOnError> =>
  (options.client ?? client).get<GetVersionResponses, GetVersionErrors, ThrowOnError>({ url: "/marketplace/admin/feed/pages/{uuid}/versions/{version}", ...options })

export const editFromVersion = <ThrowOnError extends boolean = false>(
  options: Options<EditFromVersionData, ThrowOnError>
): RequestResult<EditFromVersionResponses, EditFromVersionErrors, ThrowOnError> =>
  (options.client ?? client).post<EditFromVersionResponses, EditFromVersionErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/pages/{uuid}/versions/{version}/edit",
    ...options,
  })

export const preview = <ThrowOnError extends boolean = false>(options: Options<PreviewData, ThrowOnError>): RequestResult<PreviewResponses, PreviewErrors, ThrowOnError> =>
  (options.client ?? client).post<PreviewResponses, PreviewErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const resolve = <ThrowOnError extends boolean = false>(options: Options<ResolveData, ThrowOnError>): RequestResult<ResolveResponses, ResolveErrors, ThrowOnError> =>
  (options.client ?? client).post<ResolveResponses, ResolveErrors, ThrowOnError>({
    url: "/marketplace/admin/feed/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const allCategories = <ThrowOnError extends boolean = false>(
  options?: Options<AllCategoriesData, ThrowOnError>
): RequestResult<AllCategoriesResponses, AllCategoriesErrors, ThrowOnError> =>
  (options?.client ?? client).get<AllCategoriesResponses, AllCategoriesErrors, ThrowOnError>({ url: "/marketplace/admin/taxonomy", ...options })

export const setImage = <ThrowOnError extends boolean = false>(options: Options<SetImageData, ThrowOnError>): RequestResult<SetImageResponses, SetImageErrors, ThrowOnError> =>
  (options.client ?? client).put<SetImageResponses, SetImageErrors, ThrowOnError>({
    url: "/marketplace/admin/taxonomy/{id}/images",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const deleteUploadByBody = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUploadByBodyData, ThrowOnError>
): RequestResult<DeleteUploadByBodyResponses, DeleteUploadByBodyErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteUploadByBodyResponses, DeleteUploadByBodyErrors, ThrowOnError>({
    url: "/marketplace/admin/uploads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const upload1 = <ThrowOnError extends boolean = false>(options?: Options<Upload1Data, ThrowOnError>): RequestResult<Upload1Responses, Upload1Errors, ThrowOnError> =>
  (options?.client ?? client).post<Upload1Responses, Upload1Errors, ThrowOnError>({
    ...formDataBodySerializer,
    url: "/marketplace/admin/uploads",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  })

export const getContractPreview = <ThrowOnError extends boolean = false>(
  options: Options<GetContractPreviewData, ThrowOnError>
): RequestResult<GetContractPreviewResponses, GetContractPreviewErrors, ThrowOnError> =>
  (options.client ?? client).get<GetContractPreviewResponses, GetContractPreviewErrors, ThrowOnError>({ url: "/marketplace/checkout/contract-preview", ...options })

export const getFeaturedCoreProducts = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeaturedCoreProductsData, ThrowOnError>
): RequestResult<GetFeaturedCoreProductsResponses, GetFeaturedCoreProductsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetFeaturedCoreProductsResponses, GetFeaturedCoreProductsErrors, ThrowOnError>({ url: "/marketplace/featured-core-products", ...options })

export const getPublicRetailDisplayPaymentOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicRetailDisplayPaymentOptionsData, ThrowOnError>
): RequestResult<GetPublicRetailDisplayPaymentOptionsResponses, GetPublicRetailDisplayPaymentOptionsErrors, ThrowOnError> =>
  (options.client ?? client).post<GetPublicRetailDisplayPaymentOptionsResponses, GetPublicRetailDisplayPaymentOptionsErrors, ThrowOnError>({
    url: "/marketplace/get-display-payment-options",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getPostCheckoutPath = <ThrowOnError extends boolean = false>(
  options?: Options<GetPostCheckoutPathData, ThrowOnError>
): RequestResult<GetPostCheckoutPathResponses, GetPostCheckoutPathErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPostCheckoutPathResponses, GetPostCheckoutPathErrors, ThrowOnError>({ url: "/marketplace/post-checkout-path", ...options })

export const listCollections1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListCollections1Data, ThrowOnError>
): RequestResult<ListCollections1Responses, ListCollections1Errors, ThrowOnError> =>
  (options?.client ?? client).get<ListCollections1Responses, ListCollections1Errors, ThrowOnError>({ url: "/marketplace/store/collections", ...options })

export const getCollection1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCollection1Data, ThrowOnError>
): RequestResult<GetCollection1Responses, GetCollection1Errors, ThrowOnError> =>
  (options.client ?? client).get<GetCollection1Responses, GetCollection1Errors, ThrowOnError>({ url: "/marketplace/store/collections/{id}", ...options })

export const getProductDiscounts = <ThrowOnError extends boolean = false>(
  options: Options<GetProductDiscountsData, ThrowOnError>
): RequestResult<GetProductDiscountsResponses, GetProductDiscountsErrors, ThrowOnError> =>
  (options.client ?? client).post<GetProductDiscountsResponses, GetProductDiscountsErrors, ThrowOnError>({
    url: "/marketplace/store/custom/discounts/get-product-discounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomerData, ThrowOnError>
): RequestResult<GetCustomerResponses, GetCustomerErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCustomerResponses, GetCustomerErrors, ThrowOnError>({ url: "/marketplace/store/customers/me", ...options })

export const updateCustomer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCustomerData, ThrowOnError>
): RequestResult<UpdateCustomerResponses, UpdateCustomerErrors, ThrowOnError> =>
  (options.client ?? client).post<UpdateCustomerResponses, UpdateCustomerErrors, ThrowOnError>({
    url: "/marketplace/store/customers/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const addAddress = <ThrowOnError extends boolean = false>(
  options: Options<AddAddressData, ThrowOnError>
): RequestResult<AddAddressResponses, AddAddressErrors, ThrowOnError> =>
  (options.client ?? client).post<AddAddressResponses, AddAddressErrors, ThrowOnError>({
    url: "/marketplace/store/customers/me/addresses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const deleteAddress = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAddressData, ThrowOnError>
): RequestResult<DeleteAddressResponses, DeleteAddressErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteAddressResponses, DeleteAddressErrors, ThrowOnError>({ url: "/marketplace/store/customers/me/addresses/{addressId}", ...options })

export const updateAddress3 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAddress3Data, ThrowOnError>
): RequestResult<UpdateAddress3Responses, UpdateAddress3Errors, ThrowOnError> =>
  (options.client ?? client).post<UpdateAddress3Responses, UpdateAddress3Errors, ThrowOnError>({
    url: "/marketplace/store/customers/me/addresses/{addressId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const listOrders = <ThrowOnError extends boolean = false>(
  options?: Options<ListOrdersData, ThrowOnError>
): RequestResult<ListOrdersResponses, ListOrdersErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListOrdersResponses, ListOrdersErrors, ThrowOnError>({ url: "/marketplace/store/customers/me/orders", ...options })

export const getFeed = <ThrowOnError extends boolean = false>(options: Options<GetFeedData, ThrowOnError>): RequestResult<GetFeedResponses, GetFeedErrors, ThrowOnError> =>
  (options.client ?? client).get<GetFeedResponses, GetFeedErrors, ThrowOnError>({ url: "/marketplace/store/feed/{pageType}/{handle}", ...options })

export const getOrderByCartId1 = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderByCartId1Data, ThrowOnError>
): RequestResult<GetOrderByCartId1Responses, GetOrderByCartId1Errors, ThrowOnError> =>
  (options.client ?? client).get<GetOrderByCartId1Responses, GetOrderByCartId1Errors, ThrowOnError>({ url: "/marketplace/store/orders/cart/{cartId}", ...options })

export const getOrder2 = <ThrowOnError extends boolean = false>(options: Options<GetOrder2Data, ThrowOnError>): RequestResult<GetOrder2Responses, GetOrder2Errors, ThrowOnError> =>
  (options.client ?? client).get<GetOrder2Responses, GetOrder2Errors, ThrowOnError>({ url: "/marketplace/store/orders/{id}", ...options })

export const getOrderWithFulfillments = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderWithFulfillmentsData, ThrowOnError>
): RequestResult<GetOrderWithFulfillmentsResponses, GetOrderWithFulfillmentsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetOrderWithFulfillmentsResponses, GetOrderWithFulfillmentsErrors, ThrowOnError>({
    url: "/marketplace/store/orders/{orderId}/fulfillments",
    ...options,
  })

export const listCategories1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListCategories1Data, ThrowOnError>
): RequestResult<ListCategories1Responses, ListCategories1Errors, ThrowOnError> =>
  (options?.client ?? client).get<ListCategories1Responses, ListCategories1Errors, ThrowOnError>({ url: "/marketplace/store/product-categories", ...options })

export const getCategory1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCategory1Data, ThrowOnError>
): RequestResult<GetCategory1Responses, GetCategory1Errors, ThrowOnError> =>
  (options.client ?? client).get<GetCategory1Responses, GetCategory1Errors, ThrowOnError>({ url: "/marketplace/store/product-categories/{id}", ...options })

export const getCatalogCarousels = <ThrowOnError extends boolean = false>(
  options?: Options<GetCatalogCarouselsData, ThrowOnError>
): RequestResult<GetCatalogCarouselsResponses, GetCatalogCarouselsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCatalogCarouselsResponses, GetCatalogCarouselsErrors, ThrowOnError>({ url: "/marketplace/store/products/carousels", ...options })

export const getProductByHandle = <ThrowOnError extends boolean = false>(
  options: Options<GetProductByHandleData, ThrowOnError>
): RequestResult<GetProductByHandleResponses, GetProductByHandleErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProductByHandleResponses, GetProductByHandleErrors, ThrowOnError>({ url: "/marketplace/store/products/handle/{handle}", ...options })

export const getProduct1 = <ThrowOnError extends boolean = false>(
  options: Options<GetProduct1Data, ThrowOnError>
): RequestResult<GetProduct1Responses, GetProduct1Errors, ThrowOnError> =>
  (options.client ?? client).get<GetProduct1Responses, GetProduct1Errors, ThrowOnError>({ url: "/marketplace/store/products/{id}", ...options })

export const listReviews = <ThrowOnError extends boolean = false>(
  options: Options<ListReviewsData, ThrowOnError>
): RequestResult<ListReviewsResponses, ListReviewsErrors, ThrowOnError> =>
  (options.client ?? client).get<ListReviewsResponses, ListReviewsErrors, ThrowOnError>({ url: "/marketplace/store/products/{id}/reviews", ...options })

export const getCarousels = <ThrowOnError extends boolean = false>(
  options: Options<GetCarouselsData, ThrowOnError>
): RequestResult<GetCarouselsResponses, GetCarouselsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetCarouselsResponses, GetCarouselsErrors, ThrowOnError>({ url: "/marketplace/store/products/{productId}/carousels", ...options })

export const getOrCreateCode = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrCreateCodeData, ThrowOnError>
): RequestResult<GetOrCreateCodeResponses, GetOrCreateCodeErrors, ThrowOnError> =>
  (options?.client ?? client).post<GetOrCreateCodeResponses, GetOrCreateCodeErrors, ThrowOnError>({ url: "/marketplace/store/referrals/code", ...options })

export const previewCode = <ThrowOnError extends boolean = false>(
  options: Options<PreviewCodeData, ThrowOnError>
): RequestResult<PreviewCodeResponses, PreviewCodeErrors, ThrowOnError> =>
  (options.client ?? client).get<PreviewCodeResponses, PreviewCodeErrors, ThrowOnError>({ url: "/marketplace/store/referrals/codes/{code}", ...options })

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({ url: "/marketplace/store/referrals/me", ...options })

export const listRegions1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListRegions1Data, ThrowOnError>
): RequestResult<ListRegions1Responses, ListRegions1Errors, ThrowOnError> =>
  (options?.client ?? client).get<ListRegions1Responses, ListRegions1Errors, ThrowOnError>({ url: "/marketplace/store/regions", ...options })

export const listSitemapProducts = <ThrowOnError extends boolean = false>(
  options?: Options<ListSitemapProductsData, ThrowOnError>
): RequestResult<ListSitemapProductsResponses, ListSitemapProductsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListSitemapProductsResponses, ListSitemapProductsErrors, ThrowOnError>({ url: "/marketplace/store/sitemap/products", ...options })

export const getMyWishlist = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyWishlistData, ThrowOnError>
): RequestResult<GetMyWishlistResponses, GetMyWishlistErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMyWishlistResponses, GetMyWishlistErrors, ThrowOnError>({ url: "/marketplace/store/wishlists", ...options })

export const createWishlist = <ThrowOnError extends boolean = false>(
  options?: Options<CreateWishlistData, ThrowOnError>
): RequestResult<CreateWishlistResponses, CreateWishlistErrors, ThrowOnError> =>
  (options?.client ?? client).post<CreateWishlistResponses, CreateWishlistErrors, ThrowOnError>({ url: "/marketplace/store/wishlists", ...options })

export const getWishlist = <ThrowOnError extends boolean = false>(
  options: Options<GetWishlistData, ThrowOnError>
): RequestResult<GetWishlistResponses, GetWishlistErrors, ThrowOnError> =>
  (options.client ?? client).get<GetWishlistResponses, GetWishlistErrors, ThrowOnError>({ url: "/marketplace/store/wishlists/{id}", ...options })

export const transferWishlistToCustomer = <ThrowOnError extends boolean = false>(
  options: Options<TransferWishlistToCustomerData, ThrowOnError>
): RequestResult<TransferWishlistToCustomerResponses, TransferWishlistToCustomerErrors, ThrowOnError> =>
  (options.client ?? client).post<TransferWishlistToCustomerResponses, TransferWishlistToCustomerErrors, ThrowOnError>({
    url: "/marketplace/store/wishlists/{id}/customer",
    ...options,
  })

export const getIds = <ThrowOnError extends boolean = false>(options: Options<GetIdsData, ThrowOnError>): RequestResult<GetIdsResponses, GetIdsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetIdsResponses, GetIdsErrors, ThrowOnError>({ url: "/marketplace/store/wishlists/{id}/ids", ...options })

export const removeItem = <ThrowOnError extends boolean = false>(
  options: Options<RemoveItemData, ThrowOnError>
): RequestResult<RemoveItemResponses, RemoveItemErrors, ThrowOnError> =>
  (options.client ?? client).delete<RemoveItemResponses, RemoveItemErrors, ThrowOnError>({ url: "/marketplace/store/wishlists/{id}/items/{productId}", ...options })

export const saveItem = <ThrowOnError extends boolean = false>(options: Options<SaveItemData, ThrowOnError>): RequestResult<SaveItemResponses, SaveItemErrors, ThrowOnError> =>
  (options.client ?? client).put<SaveItemResponses, SaveItemErrors, ThrowOnError>({ url: "/marketplace/store/wishlists/{id}/items/{productId}", ...options })

export const oauth2Revoke = <ThrowOnError extends boolean = false>(
  options: Options<Oauth2RevokeData, ThrowOnError>
): RequestResult<Oauth2RevokeResponses, Oauth2RevokeErrors, ThrowOnError> =>
  (options.client ?? client).post<Oauth2RevokeResponses, Oauth2RevokeErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: "/oauth2/revoke",
    ...options,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options.headers,
    },
  })

export const oauth2Token = <ThrowOnError extends boolean = false>(
  options: Options<Oauth2TokenData, ThrowOnError>
): RequestResult<Oauth2TokenResponses, Oauth2TokenErrors, ThrowOnError> =>
  (options.client ?? client).post<Oauth2TokenResponses, Oauth2TokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: "/oauth2/token",
    ...options,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options.headers,
    },
  })

export const handoff = <ThrowOnError extends boolean = false>(options?: Options<HandoffData, ThrowOnError>): RequestResult<HandoffResponses, HandoffErrors, ThrowOnError> =>
  (options?.client ?? client).post<HandoffResponses, HandoffErrors, ThrowOnError>({ url: "/oauth2/web/handoff", ...options })

export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: "/oauth2/web/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const link1 = <ThrowOnError extends boolean = false>(options: Options<Link1Data, ThrowOnError>): RequestResult<Link1Responses, Link1Errors, ThrowOnError> =>
  (options.client ?? client).post<Link1Responses, Link1Errors, ThrowOnError>({
    url: "/oauth2/web/login/link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const pin = <ThrowOnError extends boolean = false>(options: Options<PinData, ThrowOnError>): RequestResult<PinResponses, PinErrors, ThrowOnError> =>
  (options.client ?? client).post<PinResponses, PinErrors, ThrowOnError>({
    url: "/oauth2/web/login/pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({ url: "/oauth2/web/logout", ...options })

export const resetPin1 = <ThrowOnError extends boolean = false>(options: Options<ResetPin1Data, ThrowOnError>): RequestResult<ResetPin1Responses, ResetPin1Errors, ThrowOnError> =>
  (options.client ?? client).post<ResetPin1Responses, ResetPin1Errors, ThrowOnError>({
    url: "/oauth2/web/reset-pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const session = <ThrowOnError extends boolean = false>(options?: Options<SessionData, ThrowOnError>): RequestResult<SessionResponses, SessionErrors, ThrowOnError> =>
  (options?.client ?? client).get<SessionResponses, SessionErrors, ThrowOnError>({ url: "/oauth2/web/session", ...options })

export const setPin = <ThrowOnError extends boolean = false>(options: Options<SetPinData, ThrowOnError>): RequestResult<SetPinResponses, SetPinErrors, ThrowOnError> =>
  (options.client ?? client).post<SetPinResponses, SetPinErrors, ThrowOnError>({
    url: "/oauth2/web/set-pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const signup = <ThrowOnError extends boolean = false>(options: Options<SignupData, ThrowOnError>): RequestResult<SignupResponses, SignupErrors, ThrowOnError> =>
  (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: "/oauth2/web/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const createApplicant = <ThrowOnError extends boolean = false>(
  options?: Options<CreateApplicantData, ThrowOnError>
): RequestResult<CreateApplicantResponses, CreateApplicantErrors, ThrowOnError> =>
  (options?.client ?? client).post<CreateApplicantResponses, CreateApplicantErrors, ThrowOnError>({ url: "/onfido/create-applicant", ...options })

export const createCheck = <ThrowOnError extends boolean = false>(
  options?: Options<CreateCheckData, ThrowOnError>
): RequestResult<CreateCheckResponses, CreateCheckErrors, ThrowOnError> =>
  (options?.client ?? client).post<CreateCheckResponses, CreateCheckErrors, ThrowOnError>({
    url: "/onfido/create-check",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  })

export const getOrderCustomer = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderCustomerData, ThrowOnError>
): RequestResult<GetOrderCustomerResponses, GetOrderCustomerErrors, ThrowOnError> =>
  (options.client ?? client).get<GetOrderCustomerResponses, GetOrderCustomerErrors, ThrowOnError>({ url: "/order/customer/{checkoutToken}", ...options })

export const notifyOrderVoid = <ThrowOnError extends boolean = false>(
  options: Options<NotifyOrderVoidData, ThrowOnError>
): RequestResult<NotifyOrderVoidResponses, NotifyOrderVoidErrors, ThrowOnError> =>
  (options.client ?? client).post<NotifyOrderVoidResponses, NotifyOrderVoidErrors, ThrowOnError>({
    url: "/order/notify-void",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getOrderPaymentOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderPaymentOptionsData, ThrowOnError>
): RequestResult<GetOrderPaymentOptionsResponses, GetOrderPaymentOptionsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetOrderPaymentOptionsResponses, GetOrderPaymentOptionsErrors, ThrowOnError>({ url: "/order/payment-options/{checkoutToken}", ...options })

export const getPostalCodeDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetPostalCodeDetailsData, ThrowOnError>
): RequestResult<GetPostalCodeDetailsResponses, GetPostalCodeDetailsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetPostalCodeDetailsResponses, GetPostalCodeDetailsErrors, ThrowOnError>({ url: "/postal-code-details", ...options })

export const deleteProfile = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteProfileData, ThrowOnError>
): RequestResult<DeleteProfileResponses, DeleteProfileErrors, ThrowOnError> =>
  (options?.client ?? client).delete<DeleteProfileResponses, DeleteProfileErrors, ThrowOnError>({ url: "/profile", ...options })

export const getProfile = <ThrowOnError extends boolean = false>(
  options?: Options<GetProfileData, ThrowOnError>
): RequestResult<GetProfileResponses, GetProfileErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError>({ url: "/profile", ...options })

export const putProfile = <ThrowOnError extends boolean = false>(
  options: Options<PutProfileData, ThrowOnError>
): RequestResult<PutProfileResponses, PutProfileErrors, ThrowOnError> =>
  (options.client ?? client).put<PutProfileResponses, PutProfileErrors, ThrowOnError>({
    url: "/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getLoanApplicationState = <ThrowOnError extends boolean = false>(
  options?: Options<GetLoanApplicationStateData, ThrowOnError>
): RequestResult<GetLoanApplicationStateResponses, GetLoanApplicationStateErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetLoanApplicationStateResponses, GetLoanApplicationStateErrors, ThrowOnError>({ url: "/profile/loan-application/state", ...options })

export const setUserPin = <ThrowOnError extends boolean = false>(
  options: Options<SetUserPinData, ThrowOnError>
): RequestResult<SetUserPinResponses, SetUserPinErrors, ThrowOnError> =>
  (options.client ?? client).post<SetUserPinResponses, SetUserPinErrors, ThrowOnError>({
    url: "/profile/set-pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const unauthenticatedSearch = <ThrowOnError extends boolean = false>(
  options: Options<UnauthenticatedSearchData, ThrowOnError>
): RequestResult<UnauthenticatedSearchResponses, UnauthenticatedSearchErrors, ThrowOnError> =>
  (options.client ?? client).post<UnauthenticatedSearchResponses, UnauthenticatedSearchErrors, ThrowOnError>({
    url: "/search/no-auth",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const orderPhysicalCard = <ThrowOnError extends boolean = false>(
  options: Options<OrderPhysicalCardData, ThrowOnError>
): RequestResult<OrderPhysicalCardResponses, OrderPhysicalCardErrors, ThrowOnError> =>
  (options.client ?? client).post<OrderPhysicalCardResponses, OrderPhysicalCardErrors, ThrowOnError>({
    url: "/use-everywhere/physical-card/order",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getPotentialPhysicalCardCardholderNames = <ThrowOnError extends boolean = false>(
  options?: Options<GetPotentialPhysicalCardCardholderNamesData, ThrowOnError>
): RequestResult<GetPotentialPhysicalCardCardholderNamesResponses, GetPotentialPhysicalCardCardholderNamesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPotentialPhysicalCardCardholderNamesResponses, GetPotentialPhysicalCardCardholderNamesErrors, ThrowOnError>({
    url: "/use-everywhere/physical-card/potential-cardholder-names",
    ...options,
  })

export const validateAddress = <ThrowOnError extends boolean = false>(
  options: Options<ValidateAddressData, ThrowOnError>
): RequestResult<ValidateAddressResponses, ValidateAddressErrors, ThrowOnError> =>
  (options.client ?? client).post<ValidateAddressResponses, ValidateAddressErrors, ThrowOnError>({
    url: "/use-everywhere/physical-card/validate-address",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const getIdVerificationStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetIdVerificationStatusData, ThrowOnError>
): RequestResult<GetIdVerificationStatusResponses, GetIdVerificationStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetIdVerificationStatusResponses, GetIdVerificationStatusErrors, ThrowOnError>({ url: "/user/id-verification-status", ...options })

export const bootstrapV2 = <ThrowOnError extends boolean = false>(
  options?: Options<BootstrapV2Data, ThrowOnError>
): RequestResult<BootstrapV2Responses, BootstrapV2Errors, ThrowOnError> =>
  (options?.client ?? client).get<BootstrapV2Responses, BootstrapV2Errors, ThrowOnError>({ url: "/v2/bootstrap", ...options })

export const validateCurpV3 = <ThrowOnError extends boolean = false>(
  options: Options<ValidateCurpV3Data, ThrowOnError>
): RequestResult<ValidateCurpV3Responses, ValidateCurpV3Errors, ThrowOnError> =>
  (options.client ?? client).get<ValidateCurpV3Responses, ValidateCurpV3Errors, ThrowOnError>({ url: "/v3/curp/validate", ...options })

export const signupV4 = <ThrowOnError extends boolean = false>(options: Options<SignupV4Data, ThrowOnError>): RequestResult<SignupV4Responses, SignupV4Errors, ThrowOnError> =>
  (options.client ?? client).post<SignupV4Responses, SignupV4Errors, ThrowOnError>({
    url: "/v4/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const checkSignupEmail = <ThrowOnError extends boolean = false>(
  options: Options<CheckSignupEmailData, ThrowOnError>
): RequestResult<CheckSignupEmailResponses, CheckSignupEmailErrors, ThrowOnError> =>
  (options.client ?? client).post<CheckSignupEmailResponses, CheckSignupEmailErrors, ThrowOnError>({
    url: "/v4/signup/email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  })

export const createVerificationApplicant = <ThrowOnError extends boolean = false>(
  options?: Options<CreateVerificationApplicantData, ThrowOnError>
): RequestResult<CreateVerificationApplicantResponses, CreateVerificationApplicantErrors, ThrowOnError> =>
  (options?.client ?? client).post<CreateVerificationApplicantResponses, CreateVerificationApplicantErrors, ThrowOnError>({ url: "/verification/applicant", ...options })

export const createDocumentCheck = <ThrowOnError extends boolean = false>(
  options?: Options<CreateDocumentCheckData, ThrowOnError>
): RequestResult<CreateDocumentCheckResponses, CreateDocumentCheckErrors, ThrowOnError> =>
  (options?.client ?? client).post<CreateDocumentCheckResponses, CreateDocumentCheckErrors, ThrowOnError>({ url: "/verification/check", ...options })

export const uploadDocument = <ThrowOnError extends boolean = false>(
  options?: Options<UploadDocumentData, ThrowOnError>
): RequestResult<UploadDocumentResponses, UploadDocumentErrors, ThrowOnError> =>
  (options?.client ?? client).post<UploadDocumentResponses, UploadDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: "/verification/documents",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  })
